/* NodeEmpire "Andere Version": Tracking (dataLayer), Mengen-Stepper, Sticky-CTA (nur Mobil, nach dem Hero). */
(function () {
  if (window.__neAV) return;
  window.__neAV = true;
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-track]') : null;
    if (t) {
      window.dataLayer.push({ event: 'cta_click', cta: t.getAttribute('data-track'), href: t.getAttribute('href') || undefined });
    }
    var q = e.target && e.target.closest ? e.target.closest('[data-ne-qty]') : null;
    if (q) {
      var wrap = q.closest('.ne-qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += q.getAttribute('data-ne-qty') === 'inc' ? 1 : -1;
      input.value = Math.max(1, v);
    }
  }, true);

  /* Produktkarten: Reward-Rechner (Menge x Reward je Gerät), Preis je Stück/Summe, Bildwechsel per Tipp (Touch). */
  function fmt(n, d) { return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }); }
  function money(n) { return fmt(n, Math.abs(n - Math.round(n)) < 0.005 ? 0 : 2) + ' €'; }
  function numOf(x) { var n = parseFloat(String(x == null ? '' : x).replace(',', '.')); return isFinite(n) ? n : null; }
  function setOut(card, name, text) {
    var els = card.querySelectorAll('[data-ne-out="' + name + '"]');
    for (var i = 0; i < els.length; i++) els[i].textContent = text;
  }
  function tierUnit(card, q) {
    var raw = card.getAttribute('data-tiers');
    if (!raw) return null;
    var unit = null;
    raw.split(';').forEach(function (t) {
      var p = t.split(':');
      var from = numOf(p[0]);
      var price = numOf(p[1]);
      if (from != null && price != null && q >= from) unit = price;
    });
    return unit;
  }
  function updateCard(card) {
    var input = card.querySelector('.ne-qty input');
    var q = parseInt(input && input.value, 10);
    if (!isFinite(q) || q < 1) q = 1;
    var reward = numOf(card.getAttribute('data-reward'));
    var unit = tierUnit(card, q);
    var tiered = unit != null;
    if (unit == null) unit = numOf(card.getAttribute('data-unit'));
    var sel = card.querySelector('[data-ne-model]');
    var seg = card.querySelector('[data-ne-model-opt]:checked');
    var o = seg || (sel && sel.options.length ? sel.options[sel.selectedIndex] : null);
    if (o) {
      reward = numOf(o.getAttribute('data-reward'));
      var mp = numOf(o.getAttribute('data-price'));
      if (mp != null) {
        unit = mp;
        setOut(card, 'price', fmt(mp, 0) + ' €');
      }
      var lb = o.getAttribute('data-label');
      if (lb) setOut(card, 'model', lb);
    }
    if (reward != null) {
      setOut(card, 'reward', fmt(reward * q, 2));
      setOut(card, 'per', fmt(reward, 2));
    }
    if (tiered) setOut(card, 'price', money(unit));
    if (card.getAttribute('data-total') && unit != null) {
      setOut(card, 'unit', money(unit));
      setOut(card, 'sum', money(unit * q));
    }
  }
  function updateAll() {
    var cards = document.querySelectorAll('[data-ne-card]');
    for (var i = 0; i < cards.length; i++) updateCard(cards[i]);
  }
  function cardOf(t) { return t && t.closest ? t.closest('[data-ne-card]') : null; }
  document.addEventListener('input', function (e) {
    var c = cardOf(e.target);
    if (c) updateCard(c);
  });
  document.addEventListener('change', function (e) {
    var c = cardOf(e.target);
    if (!c) return;
    updateCard(c);
  });
  document.addEventListener('click', function (e) {
    var c = cardOf(e.target);
    if (c && e.target.closest('[data-ne-qty]')) updateCard(c);
    var sw = e.target && e.target.closest ? e.target.closest('[data-ne-swap]') : null;
    if (sw && window.matchMedia && window.matchMedia('(hover: none)').matches) sw.classList.toggle('is-alt');
  });
  /* Details-Hinweis: schließt bei Klick daneben oder Escape */
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('.ne-info[open]');
    for (var i = 0; i < open.length; i++) if (!open[i].contains(e.target)) open[i].removeAttribute('open');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.ne-info[open]');
    for (var i = 0; i < open.length; i++) open[i].removeAttribute('open');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else updateAll();

  function initSticky() {
    var bar = document.querySelector('[data-ne-sticky]');
    var hero = document.getElementById('ne-hero');
    if (!bar || !hero) return;
    var link = bar.querySelector('a');
    function update() {
      var on = hero.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (link) link.setAttribute('tabindex', on ? '0' : '-1');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
